"use client";

import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import type { ApiIdentity } from "@/generated/models/ApiIdentity";
import UserStatsRow from "../../utils/stats/UserStatsRow";
import UserPageFollowersModal from "../../followers/UserPageFollowersModal";
const SAFE_ROUTE_SEGMENT_PATTERN = /^[a-zA-Z0-9._-]+$/;
function sanitizeRouteSegment(value: string): string | null {
  if (!value) {
    return null;
  }
  const trimmedValue = value.trim();
  if (!trimmedValue) {
    return null;
  }
  const normalizedValue = trimmedValue.toLowerCase();
  if (!SAFE_ROUTE_SEGMENT_PATTERN.test(normalizedValue)) {
    return null;
  }
  return encodeURIComponent(normalizedValue);
}
export default function UserPageHeaderStats(t0) {
  const $ = _c(19);
  const {
    profile,
    handleOrWallet,
    followersCount
  } = t0;
  const [isFollowersModalOpen, setIsFollowersModalOpen] = useState(false);
  let t1;
  if ($[0] !== handleOrWallet) {
    t1 = sanitizeRouteSegment(handleOrWallet);
    $[0] = handleOrWallet;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const routeHandle = t1;
  if (!routeHandle) {
    return null;
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => setIsFollowersModalOpen(true);
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== followersCount || $[4] !== profile.cic || $[5] !== profile.rep || $[6] !== profile.tdh || $[7] !== profile.tdh_rate || $[8] !== profile.xtdh || $[9] !== profile.xtdh_rate || $[10] !== routeHandle) {
    t3 = <UserStatsRow handle={routeHandle} tdh={profile.tdh} tdh_rate={profile.tdh_rate} xtdh={profile.xtdh} xtdh_rate={profile.xtdh_rate} rep={profile.rep} cic={profile.cic} followersCount={followersCount} onFollowersClick={t2} />;
    $[3] = followersCount;
    $[4] = profile.cic;
    $[5] = profile.rep;
    $[6] = profile.tdh;
    $[7] = profile.tdh_rate;
    $[8] = profile.xtdh;
    $[9] = profile.xtdh_rate;
    $[10] = routeHandle;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => setIsFollowersModalOpen(false);
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== isFollowersModalOpen || $[14] !== profile.id) {
    t5 = <UserPageFollowersModal profileId={profile.id} isOpen={isFollowersModalOpen} onClose={t4} />;
    $[13] = isFollowersModalOpen;
    $[14] = profile.id;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== t3 || $[17] !== t5) {
    t6 = <div className="tw-w-full">{t3}{t5}</div>;
    $[16] = t3;
    $[17] = t5;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  return t6;
}